import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Dashboard } from "../../components/Dashboard/Dashboard";
import DataTable from "react-data-table-component";
import { Circular } from "../../components/Circular/Circular";
import connectTopLine from "../../components/HOC/connectTopLine";
import { applyCurrencyFormatters } from "../../common/helper";
import "bootstrap/dist/css/bootstrap.min.css";
import Export from "../../components/Export/Export";
import { toastApiError } from "../../utils/toastApiError";
import useAuth from "../../auth/useAuth";
import { httpApi } from "../../api/httpApi";

const perPageList = [10, 50, 100];

const Casinos = ({ datesFilter, brandsFilter }) => {
  const auth = useAuth();
  const [stats, setStats] = useState({});
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    httpApi
        .doGet(`/api/v3/reports/casinos?page=1&per_page=10000&${brandsFilter}&${datesFilter}`)
        .then((response) => {
          setReports(response.reports);
          setStats(response.totalsReport);
        })
        .catch(toastApiError)
        .finally(() => setLoading(false))
  }, [brandsFilter, datesFilter]);

  const columns = [
    {
      name: "Casinos",
      selector: (row) => row.brandName,
      sortable: true,
    },
    {
      name: "Clicks",
      selector: (row) => row.uniqueClicks,
      sortable: true,
      center: true,
    },
    {
      name: "Registrations",
      selector: (row) => row.registrations,
      sortable: true,
      center: true,
    },
    {
      name: "FTDs",
      selector: (row) => row.ftds,
      sortable: true,
      center: true,
    },
    {
      name: "Deposits",
      selector: (row) => row.numberOfDeposits,
      sortable: true,
      center: true,
      omit: !auth.user.authorities.includes('VIEW_DEPOSITS')
    },
    {
      name: "Deposits Value",
      selector: (row) => row.deposits,
      sortable: true,
      format: "currency",
      center: true,
      omit: !auth.user.authorities.includes('VIEW_DEPOSITS')
    },
    {
      name: "Net Cash",
      selector: (row) => row.netCash,
      sortable: true,
      format: "currency",
      center: true,
      omit: !auth.user.authorities.includes('VIEW_NET_CASH')
    },
    {
      name: "Rev Share Commission",
      selector: (row) => row.revShareCommission,
      sortable: true,
      format: "currency",
      center: true,
    },
    {
      name: "CPA Commission",
      selector: (row) => row.cpaCommission,
      sortable: true,
      format: "currency",
      center: true,
    },
  ];

  return (
    <Row>
      <Dashboard stats={stats} />
      <div className="data__wrapper">
        <DataTable theme="darkCustom"
          title="Casinos"
          columns={applyCurrencyFormatters(columns)}
          data={reports}
          progressPending={loading}
          pagination
          progressComponent={<Circular />}
          paginationRowsPerPageOptions={perPageList}
          actions={<Export rows={reports} />}
        />
      </div>
    </Row>
  );
};

export default connectTopLine(true, false, Casinos);
